import React, { useEffect, useState } from "react";

import licenses from "../licenses.json";

import { HeroTeaser, Main, Table, ContentSection, Wrapper } from "@vwfs-bronson/bronson-react";

export const LicensesPage = () => {
    const [MIT, setMIT] = useState([]);

    useEffect(() => {
        if (licenses) {
            let dependencies = Object.entries(licenses);
            dependencies.forEach(function (element) {
                if (element && element.length > 1) {
                    switch (element[1].licenses) {
                        case "MIT":
                            setMIT((x) => [...x, element[0]]);
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    }, []);

    return (
        <>
            <HeroTeaser
                title={["Aviso de licencia de terceros"]}
                sub={"Las siguientes licencias de terceros se utilizan en este sitio web:"}
                shallow
                noImage
            />
            <Main>
                <ContentSection pageWrapSize="medium">
                    <Wrapper>
                        <h3 className="u-text-center">Licencia-MIT</h3>
                        {
                            <Table noHover responsive tableHeader={["Nombre", "Version"]}>
                                <Table.Thead>
                                    <Table.Tr>
                                        <Table.Th>Nombre</Table.Th>
                                        <Table.Th>Version</Table.Th>
                                    </Table.Tr>
                                </Table.Thead>
                                <Table.Tbody>
                                    {MIT.map((x, index) => (
                                        <Table.Tr key={index}>
                                            <Table.Td>{x.split("@")[0]}</Table.Td>
                                            <Table.Td>{x.split("@")[1]}</Table.Td>
                                        </Table.Tr>
                                    ))}
                                </Table.Tbody>
                            </Table>
                        }
                        <p>
                            View license:{" "}
                            <a
                                href="https://opensource.org/licenses/mit-license.php"
                                target={"_blank"}
                                rel="noreferrer"
                            >
                                MIT License
                            </a>{" "}
                        </p>
                        <p>
                            Permission is hereby granted, free of charge, to any person obtaining a copy of this
                            software and associated documentation files (the Software), to deal in the Software without
                            restriction, including without limitation the rights to use, copy, modify, merge, publish,
                            distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom
                            the Software is furnished to do so, subject to the following conditions:The above copyright
                            notice and this permission notice shall be included in all copies or substantial portions of
                            the Software.
                            <br /> THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
                            INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE
                            FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
                            DEALINGS IN THE SOFTWARE.
                        </p>
                    </Wrapper>
                </ContentSection>
            </Main>
        </>
    );
};
